(function () {
  'use strict';

  function initProductGalleries($) {
    $('[data-makeen-product-gallery]').each(function () {
      var gallery = this;
      var $gallery = $(gallery);
      var $main = $gallery.find('.makeen-product-gallery__main');
      var $thumbButtons = $gallery.find('[data-gallery-index]');
      var counter = gallery.querySelector('[data-gallery-current]');

      function clearZoom() {
        $gallery.find('.makeen-product-gallery__zoom').each(function () {
          this.classList.remove('is-zooming');
          this.style.removeProperty('--makeen-zoom-x');
          this.style.removeProperty('--makeen-zoom-y');
        });
      }

      function updateActiveState(index) {
        $thumbButtons.attr('aria-current', 'false');
        $thumbButtons.filter('[data-gallery-index="' + index + '"]').attr('aria-current', 'true');

        if (counter) {
          counter.textContent = index + 1;
        }

        clearZoom();
      }

      $thumbButtons.on('click.makeenGallery', function () {
        var index = Number(this.getAttribute('data-gallery-index'));

        if ($main.hasClass('slick-initialized')) {
          $main.slick('slickGoTo', index);
        }

        updateActiveState(index);
      });

      $thumbButtons.on('keydown.makeenGallery', function (event) {
        var currentIndex = Number(this.getAttribute('data-gallery-index'));
        var lastIndex = $thumbButtons.length - 1;
        var nextIndex = null;

        if (event.key === 'ArrowDown' || event.key === 'ArrowRight') {
          nextIndex = Math.min(currentIndex + 1, lastIndex);
        } else if (event.key === 'ArrowUp' || event.key === 'ArrowLeft') {
          nextIndex = Math.max(currentIndex - 1, 0);
        } else if (event.key === 'Home') {
          nextIndex = 0;
        } else if (event.key === 'End') {
          nextIndex = lastIndex;
        }

        if (nextIndex !== null) {
          event.preventDefault();
          $thumbButtons.eq(nextIndex).trigger('focus').trigger('click');
        }
      });

      if ($main.hasClass('slick-initialized')) {
        $main.on('afterChange.makeenGallery', function (event, slick, currentSlide) {
          updateActiveState(currentSlide);
        });
      }

      if (window.matchMedia('(hover: hover) and (pointer: fine)').matches) {
        $gallery.find('.makeen-product-gallery__zoom--enabled').each(function () {
          var zoomTarget = this;

          zoomTarget.addEventListener('mouseenter', function () {
            zoomTarget.classList.add('is-zooming');
          });

          zoomTarget.addEventListener('mousemove', function (event) {
            var bounds = zoomTarget.getBoundingClientRect();
            var x = ((event.clientX - bounds.left) / bounds.width) * 100;
            var y = ((event.clientY - bounds.top) / bounds.height) * 100;

            zoomTarget.style.setProperty('--makeen-zoom-x', x + '%');
            zoomTarget.style.setProperty('--makeen-zoom-y', y + '%');
          });

          zoomTarget.addEventListener('mouseleave', function () {
            zoomTarget.classList.remove('is-zooming');
          });
        });
      }

      updateActiveState(0);
    });
  }

  if (window.jQuery) {
    window.jQuery(function ($) {
      initProductGalleries($);
    });
  }
}());
